import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * usePelangganSuggestions — debounced fetch of past pelanggan+alamat pairs
 * for the SPB create form autocomplete. Empty query resets the list.
 */
export default function usePelangganSuggestions(query, delay = 250) {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const q = (query || "").trim();
    if (q.length < 2) {
      setSuggestions([]);
      return undefined;
    }
    const handle = setTimeout(() => {
      api.get("/pelanggan/suggest", { params: { q, limit: 8 } })
        .then((r) => setSuggestions(r.data || []))
        .catch(() => setSuggestions([]));
    }, delay);
    return () => clearTimeout(handle);
  }, [query, delay]);

  return suggestions;
}
